module.exports = __webpack_public_path__ + "img/emergencySupplies_uncheck.30668f58.png";